import { Fragment } from 'react';
//===========import components================
import Header from 'partials/Header';
import Footer from 'partials/Footer';

const SubPagesLayout =
  (componentProps) =>
  (Component) =>
  ({ ...props }) => {
    return (
      <Fragment>
        <section
          className='homePageLayout z-10 flex flex-col justify-between relative lg:bg-transparent'
          style={{
            background: `url("/assets/gifs/homeGif.gif") no-repeat center/cover`,
          }}>
          <div className='overlay z-0'></div>
          <Header />
          <div className='homeBannerContent max-w-7xl mx-auto w-full flex flex-col pt-48 sm:pt-56 pb-16 sm:pb-24 px-6 md:px-8 2xl:px-0 relative'>
            <h1 className='font-medium text-white text-xl sm:text-4xl uppercase text-center'>
              {componentProps?.route}
            </h1>
          </div>
        </section>
        <Component {...props} />
        <Footer />
      </Fragment>
    );
  };

export default SubPagesLayout;
